import React, { Component } from 'react'
import MoreMenuPage from '../components/MoreMenu/MoreMenuPage';
import { MORE_MENU_TYPES } from '../global/Enum';

class PrivacyPolicy extends Component {
    render() {
        return (
            <div>                
                <MoreMenuPage selectedTab={MORE_MENU_TYPES.PRIVACY_POLICY} />
            </div>
        )
    }
}

export default PrivacyPolicy